

export const Texts_MIX = {
    LABELS: {
        supportIdeas: "Ideen unterstützen",
        promoteInnovation: "Innovationen fördern",
        supportGrowth: "Wachstum begleiten",
        createValue: "Werte schaffen",
    }
}

export default Texts_MIX;